// extracted by mini-css-extract-plugin
module.exports = {"filters":"_33qyVPetWeYoJIlkVFiz82","filterLabel":"_1r5CjBQZLjDSJ7E-7N88k4","filterLabelIcon":"MdrVrJkOm8JxBfiPvn6gK"};